import React, {PureComponent} from 'react'
import withStyles from '@mui/styles/withStyles';
import Fade from "@mui/material/Fade";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import DeleteIcon from '@mui/icons-material/Delete';
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import {Avatar} from "@mui/material";
import {ColorPicker} from "../../../core/colors/ColorPicker";
import CardActionArea from "@mui/material/CardActionArea";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import LineGraph from "../../graphs/LineGraph";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {withRouter} from "../../../hooks/withRouter";
import EditIcon from "@mui/icons-material/Edit";

const useStyles = theme => ({
	grow: {
		flexGrow: 1,
	},
});

class MeasurementCard extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			measurement: this.props.measurement,
			dropDownMenuAnchorEl: null,
			isCollapseOpen: true,
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({
			measurement: nextProps.measurement,
			dropDownMenuAnchorEl: null
		});
	}

	openDropdownMenu = (event) => {
		event.stopPropagation();
		this.setState({
			dropDownMenuAnchorEl: event.currentTarget,
		});
	};

	closeDropdownMenu = (event) => {
		event.stopPropagation();
		this.setState({
			dropDownMenuAnchorEl: null
		});
	};

	triggerCollapse = () => {
		this.setState({
			isCollapseOpen: !this.state.isCollapseOpen
		});
	}

	getLineGraphData = () => {
		let x = [];
		let y = [];

		this.state.measurement.logs.forEach(log => {
			x.push((new Date(log.dateCreated)).toLocaleDateString());
			y.push(log.value);
		});

		return {
			x: x.reverse(),
			y: y.reverse(),
			label: this.state.measurement ? this.state.measurement.name : ''
		};
	}

	getLatestValue = () => {
		const logs = this.state.measurement.logs;
		if (!logs || logs.length === 0) return null;
		return logs[0].value;
	}

	render() {
		const {classes} = this.props;
		const measurement = this.state.measurement;
		const logCount = measurement.logs ? measurement.logs.length : 0;
		const latestValue = this.getLatestValue();

		const subParts = [];
		if (latestValue !== null) subParts.push(`Latest: ${latestValue}`);
		if (logCount > 0) subParts.push(`${logCount} log${logCount !== 1 ? 's' : ''}`);

		return (
			<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
				<CardActionArea onClick={() => this.props.setBloopOpen(measurement)}>
					<CardHeader
						sx={{ pb: 0.5 }}
						title={
							<Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
								{measurement.name}
							</Typography>
						}
						subheader={
							subParts.length > 0 && (
								<Typography variant="caption" sx={{ color: 'text.secondary' }}>
									{subParts.join(' · ')}
								</Typography>
							)
						}
						avatar={
							<Avatar sx={{
								bgcolor: measurement.color || ColorPicker.pick(measurement.name),
								width: 38,
								height: 38,
								fontSize: 16,
								fontWeight: 600,
							}}>
								{measurement.name.charAt(0).toUpperCase()}
							</Avatar>
						}
						action={
							<span>
								<IconButton
									id={measurement.id}
									size="small"
									onClick={this.openDropdownMenu}
								>
									<MoreVertIcon fontSize="small"/>
								</IconButton>
								<Menu
									anchorEl={this.state.dropDownMenuAnchorEl}
									open={Boolean(this.state.dropDownMenuAnchorEl)}
									onClose={this.closeDropdownMenu}
									TransitionComponent={Fade}
								>
									<MenuItem onClick={this.props.editSelfFunc}>
										<ListItemIcon>
											<EditIcon fontSize="small" />
										</ListItemIcon>
										<ListItemText primary="Edit"/>
									</MenuItem>
									<MenuItem onClick={this.props.deleteSelfFunc}>
										<ListItemIcon>
											<DeleteIcon fontSize="small"/>
										</ListItemIcon>
										<ListItemText primary="Delete"/>
									</MenuItem>
								</Menu>
							</span>
						}
					/>
				</CardActionArea>

				{logCount > 0 && (
					<Collapse in={this.state.isCollapseOpen}>
						<Divider/>
						<CardContent sx={{ py: 1, '&:last-child': { pb: 1 } }}>
							<LineGraph data={this.getLineGraphData()} showLegend={false}/>
						</CardContent>
					</Collapse>
				)}

				<CardActions disableSpacing sx={{ px: 1.5, py: 0.75 }}>
					{this.props.dragHandle}

					<div className={classes.grow}/>

					{logCount > 0 && (
						<IconButton size="small" onClick={this.triggerCollapse} sx={{ mr: 0.5 }}>
							{this.state.isCollapseOpen ? <ExpandLess fontSize="small"/> : <ExpandMore fontSize="small"/>}
						</IconButton>
					)}

					<Button
						size="small"
						onClick={() => this.props.setBloopOpen(measurement)}
						sx={{ textTransform: 'none', fontWeight: 600, fontSize: 13 }}
					>
						Open
					</Button>
				</CardActions>
			</Card>
		);
	}
}

export default withStyles(useStyles)(withRouter(MeasurementCard));
